
import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { format } from 'date-fns';
import { ScheduleData } from './types';

export const useScheduleDataLoader = () => {
  const loadScheduleData = useCallback(async (
    psychologistId: string,
    startDate: Date,
    endDate: Date
  ): Promise<ScheduleData[]> => {
    console.log('🔍 STEP 1: useScheduleDataLoader iniciado');
    console.log('🚀 [useScheduleDataLoader] Carregando dados para psicólogo:', {
      psychologistId,
      type: typeof psychologistId,
      isValid: !!psychologistId,
      isUUID: psychologistId ? /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(psychologistId) : false
    });

    if (!psychologistId) {
      console.error('❌ [useScheduleDataLoader] ERRO CRÍTICO: Sem psychologistId, abortando');
      return [];
    }

    const startDateStr = format(startDate, 'yyyy-MM-dd');
    const endDateStr = format(endDate, 'yyyy-MM-dd');
    
    console.log('🎯 [useScheduleDataLoader] Executando query na database...', {
      query: {
        table: 'psychologist_schedule',
        psychologist_id: psychologistId,
        is_active: true,
        date_gte: startDateStr,
        date_lte: endDateStr
      }
    });

    const { data: rawData, error } = await supabase
      .from('psychologist_schedule')
      .select('*')
      .eq('psychologist_id', psychologistId)
      .eq('is_active', true)
      .gte('date', startDateStr)
      .lte('date', endDateStr)
      .order('date', { ascending: true })
      .order('start_time', { ascending: true });

    if (error) {
      console.error('❌ [useScheduleDataLoader] ERRO NA QUERY:', error);
      console.log('🔍 STEP 2: Dados chegam do banco - ERRO:', error);
      throw error;
    }

    console.log('🔍 STEP 2: Dados chegam do banco - SUCESSO:', {
      count: rawData?.length || 0,
      rawData: rawData,
      firstRecord: rawData?.[0],
      dates: rawData?.map(r => r.date) || [],
      uniqueDates: [...new Set(rawData?.map(r => r.date) || [])]
    });

    return rawData || [];
  }, []);

  return { loadScheduleData };
};
